export const STORY_SECTION = {
  JOURNEY_TITLE: "Each client's journey follows a holistic path:",
  BUTTON_LABEL: 'Explore Our Services',
};
